const PUBLIC_ROUTERS = {
  root: '/',
  authBridge: '/auth-bridge',
  help: '/help',
  noAccount: '/no-account',
  oauth: { callback: '/oauth/callback' },
}

const Main_ROUTES = {
  dashboard: '/dashboard',
  timeEntries: '/time-entries',
  reports: '/reports',
  settings: '/settings',
}

export const ROUTER_PATH = { ...PUBLIC_ROUTERS, ...Main_ROUTES }

export const DEFAULT_WORKSPACE_PAGE = 'dashboard'
